export default __webpack_public_path__ + "static/media/work.af34b579.svg";